module.exports = __webpack_public_path__ + "assets/img/4dfe8897b596cfd19380c118f5a2d76f.png";